import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class ConfigTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "parameterColumn", title: "Parameter" },
        { name: "valueColumn", title: "Description" }
      ],
      rows: [
        { parameterColumn: 'Liste vordefinierter Antworten', valueColumn: 'Wählen Sie hier nichts aus, also lassen Sie hier den Eintrag auf -- bitte auswählen --' },
        { parameterColumn: 'Liste der angeschlossenen Endgeräte', valueColumn: 'Wählen Sie hier nichts aus, also lassen Sie hier den Eintrag auf -- bitte auswählen --' },
        { parameterColumn: 'Name', valueColumn: 'Wählen Sie hier einen Namen für Ihre Kamera, zB. Kamera Garage.' },
        { parameterColumn: 'Adress-Typ', valueColumn: 'Wählen Sie hier IPv4 aus.' },
        { parameterColumn: 'Computer', valueColumn: 'Tragen Sie hier die lokale IP-Adresse Ihrer Kamera ein, die Sie in Schritt 1 festgelegt hatten (192.168.100.201).' },
        { parameterColumn: 'Protokoll', valueColumn: 'Wählen Sie hier TCP' },
        { parameterColumn: 'LAN-Port', valueColumn: 'Geben Sie hier den Port Ihrer Kamera ein, also wie aus Schritt 1 die 8081 für Kamera 1. Falls Sie weitere Kameras hinzufügen, ändern Sie für diese dann jeweils den zugehörigen Port (8082 für Kamera 2 usw.)' },
        { parameterColumn: 'Öffentlicher Port', valueColumn: '	Geben Sie hier den Port Ihrer Kamera ein, also wie aus Schritt 1 die 8081 für Kamera 1. Falls Sie weitere Kameras hinzufügen, ändern Sie für diese dann jeweils den zugehörigen Port (8082 für Kamera 2 usw.)' },
        { parameterColumn: 'Externer Computer', valueColumn: 'Tragen Sie hier nichts ein, lassen Sie also die Adresse auf 0.0.0.0' },
        { parameterColumn: 'Quellzone', valueColumn: 'Wählen Sie hier Internet/NTP/TR069/VoIP' },
        { parameterColumn: 'Status', valueColumn: 'Setzen Sie hier den Haken.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

ConfigTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(ConfigTable)